import { Client } from "./Client";

export const api = new Client();